module.exports = __webpack_public_path__ + "img/blue_176.1f35450d.png";